<template>
  <svg id="dash" class="lds-dash-ring" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <circle class="segment stagger-1" cx="50" cy="50" r="30" stroke="#1769bd" fill="none" stroke-dasharray="18.84955592153876 188.49555921538757" stroke-linecap="round" stroke-width="5"></circle>
    <circle class="segment stagger-2" cx="50" cy="50" r="30" stroke="#cc007b" fill="none" stroke-dasharray="18.84955592153876 188.49555921538757" stroke-linecap="round" stroke-width="5" transform="rotate(72 50 50)"></circle>
    <circle class="segment stagger-3" cx="50" cy="50" r="30" stroke="#67c7c7" fill="none" stroke-dasharray="18.84955592153876 188.49555921538757" stroke-linecap="round" stroke-width="5" transform="rotate(144 50 50)"></circle>
    <circle class="segment stagger-4" cx="50" cy="50" r="30" stroke="#e6e7e7" fill="none" stroke-dasharray="18.84955592153876 188.49555921538757" stroke-linecap="round" stroke-width="5" transform="rotate(216 50 50)"></circle>
    <circle class="segment stagger-5" cx="50" cy="50" r="30" stroke="#1769bd" fill="none" stroke-dasharray="18.84955592153876 188.49555921538757" stroke-linecap="round" stroke-width="5" transform="rotate(288 50 50)"></circle>
  </svg>
</template>
<script>
export default {
  name: "Spinner",
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  }
}
</script>
<style>
.lds-dash-ring {
  animation: spin 2s linear infinite;
  display: block;
  transform-origin: 50%;
}

.segment {
  animation: colorize 2s infinite linear;
}

.stagger-1 {
  animation-delay: -2000ms;
}

.stagger-2 {
  animation-delay: -1500ms;
}

.stagger-3 {
  animation-delay: -1000ms;
}

.stagger-4 {
  animation-delay: -500ms;
}

.stagger-5 {
  animation-delay: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes colorize {
  0% {
    stroke: #1769bd;
  }

  25% {
    stroke: #cc007b;
  }

  50% {
    stroke: #67c7c7;
  }

  75% {
    stroke: #e6e7e7;
  }

  100% {
    stroke: #1769bd;
  }
}
</style>